import React, { useEffect, useState } from 'react';
import Input from 'components/common/Input';
import { Card, Col, Row } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import TooltipBadge from 'components/common/TooltipBadge';
import { useSearchParams } from 'react-router-dom';
import { newProductForm } from 'schemas/product.schema';

const ProductType = () => {
 const {
  watch,
  reset,
  setValue,
  register,
  getValues,
  formState: { errors }
 } = useFormContext();

 const [searchParams, setSearchParams] = useSearchParams();

 const [type, tags, categories] = watch(['type', 'tags', 'categories']);

 const setTags = () => tags.map(e => ({ value: e, label: e })) ?? [];
 const setCategories = () => categories.map(e => ({ value: e, label: e })) ?? [];

 const [typeItem, setTypeItem] = useState(getValues('type'));
 const [options, setOptions] = useState({
  tags: setTags(),
  categories: setCategories(),

  tagOptions: setTags(),
  categoryOptions: setCategories()
 });

 const createOption = (type, value) => {
  const option = type === 'tags' ? 'tagOptions' : 'categoryOptions';
  setOptions({ ...options, [option]: [...options[option], { label: value, value }] });
  setValue(type, [...getValues(type), value]);
 };

 useEffect(() => {
  searchParams.set('type', type);
  setSearchParams(searchParams);

  if (typeItem !== type) {
   setTypeItem(type);
   reset({ ...newProductForm.defaultValues, type });
  }
 }, [type]);

 useEffect(() => {
  setOptions({ ...options, tags: setTags() });
 }, [tags]);

 useEffect(() => {
  setOptions({ ...options, categories: setCategories() });
 }, [categories]);

 return (
  <Card className="mb-3">
   <Card.Header as="h6" className="bg-body-tertiary">
    config. de producto
   </Card.Header>
   <Card.Body>
    <div>
     <h6 className="">
      ¿Tipo de producto?
      <TooltipBadge tooltip="Tipo de producto a configurar" icon="question-circle" />
     </h6>
     <div className="ps-2 mb-2">
      <Input
       name="type"
       type="radio"
       errors={errors}
       label="Producto"
       formGroupProps={{ className: 'form-label-nogutter' }}
       formControlProps={{ value: 'product', ...register('type') }}
      />
      <Input
       name="type"
       type="radio"
       label="Receta"
       errors={errors}
       formGroupProps={{ className: 'form-label-nogutter' }}
       formControlProps={{ value: 'recipe', ...register('type') }}
      />
      <Input
       name="type"
       type="radio"
       label="Combo"
       errors={errors}
       formGroupProps={{ className: 'form-label-nogutter' }}
       formControlProps={{ value: 'combo', ...register('type') }}
      />
     </div>
    </div>

    <div className="border-dashed border-bottom my-3" />

    <div>
     <h6 className="">
      ¿Estado del inventario?
      <TooltipBadge tooltip="Estado de inventario" icon="question-circle" />
     </h6>
     <div className="ps-2 mb-2">
      <Input
       type="radio"
       errors={errors}
       name="stock"
       label="Inventariado"
       formGroupProps={{ className: 'form-label-nogutter' }}
       formControlProps={{ value: 'inventory', ...register('stock') }}
      />
      <Input
       type="radio"
       errors={errors}
       name="stock"
       label="Disponible"
       formGroupProps={{ className: 'form-label-nogutter' }}
       formControlProps={{ value: 'available', ...register('stock') }}
      />
      <Input
       type="radio"
       errors={errors}
       name="stock"
       label="No disponible"
       formGroupProps={{ className: 'form-label-nogutter' }}
       formControlProps={{ value: 'unavailable', ...register('stock') }}
      />
     </div>
    </div>

    <div className="border-dashed border-bottom my-3" />

    <Row className="gx-2 gy-3">
     <Input
      type="selectMulti"
      name="categories"
      errors={errors}
      placeholder="Seleccione..."
      options={options?.categoryOptions}
      label="Seleccione categoria(s):"
      formGroupProps={{ as: Col, md: 12 }}
      formControlProps={{
       maxItems: 2,
       isClearable: true,
       isMulti: true,
       closeMenuOnSelect: true,
       value: options?.categories,
       onCreateOption: e => createOption('categories', e),
       onChange: newValue => {
        const values = newValue.map(e => e.value);
        console.log({ values });
        setValue('categories', values, { shouldValidate: true });
       }
      }}
     />

     <Input
      type="selectMulti"
      name="tags"
      errors={errors}
      placeholder="Seleccione..."
      options={options?.tagOptions}
      label="Añade una palabra clave:"
      formGroupProps={{ as: Col, md: 12 }}
      formControlProps={{
       isClearable: true,
       isMulti: true,
       closeMenuOnSelect: true,
       value: options?.tags,
       onCreateOption: e => createOption('tags', e),
       onChange: newValue => {
        const values = newValue.map(e => e.value);
        setValue('tags', values, { shouldValidate: true });
       }
      }}
     />
    </Row>
   </Card.Body>
  </Card>
 );
};

export default ProductType;
